module.exports = __webpack_public_path__ + "static/img/01_lea_cornelius_carstens.d9cc2fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/lea/01_lea_cornelius_carstens.jpg
// module id = wEhA
// module chunks = 1